<h2 style="font-family: Roboto; font-style: normal; font-weight: bold; font-size: 200%; text-align: center;">Munkalap
  részletek</h2>
<mat-list class="list">
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Minőség</b> {{post.concreteQuality}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Mennyiség</b> {{post.concreteQuantity}} m³</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Megrendelő</b> {{post.customer}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Megrendelő kód</b> {{post.customerCode}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Honnan</b> {{post.fromLocation}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Hová</b> {{post.toLocation}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Telefonszám</b> {{post.phoneNumber}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Dátum</b> {{post.date}} {{post.hour}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Felhasználó</b> {{post.userName}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Rendszámok</b></span> </h3>
  </mat-list-item>
  <mat-list-item *ngFor="let number of post.licensePlateNumbers">{{number}}</mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item class="no-wrap">
    <h3 class="name"> <span class="nobreak"> <b>Megjegyzés</b> {{post.comment}}</span> </h3>
  </mat-list-item>
  <mat-divider></mat-divider>
</mat-list>
<mat-list></mat-list>